import { useTheme } from "@/contexts/ThemeContext";

export const AppLogo = ({ size = "default", showText = true, className = "" }) => {
  const themeCtx = useTheme?.();
  const isDark = themeCtx?.isDark ?? true;

  const sizes = {
    sm: { icon: 28, text: "text-base" },
    default: { icon: 36, text: "text-xl" },
    lg: { icon: 44, text: "text-2xl" },
    xl: { icon: 56, text: "text-3xl" },
  };

  const s = sizes[size] || sizes.default;

  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="app-logo">
      {/* Brain + Waveform Icon */}
      <div
        className="relative shrink-0 flex items-center justify-center rounded-xl"
        style={{
          width: s.icon + 8,
          height: s.icon + 8,
          background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 40%, #06b6d4 100%)",
        }}
        data-testid="app-logo-icon"
      >
        <svg
          width={s.icon}
          height={s.icon}
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Brain outline */}
          <path
            d="M24 6C18.5 6 14 9.5 13 14C10.5 14.5 8 17 8 20.5C8 23 9 25 10.5 26.5C9.5 28 9 30 9 32C9 36 12 39 16 39.5C17 41.5 19.5 43 22.5 43C23 43 23.5 42.95 24 42.9M24 6C29.5 6 34 9.5 35 14C37.5 14.5 40 17 40 20.5C40 23 39 25 37.5 26.5C38.5 28 39 30 39 32C39 36 36 39 32 39.5C31 41.5 28.5 43 25.5 43C25 43 24.5 42.95 24 42.9M24 6V42.9"
            stroke="white"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
            opacity="0.9"
          />
          {/* Audio waveform inside brain */}
          <path
            d="M16 24L18 20L20 28L22 18L24 30L26 16L28 28L30 20L32 24"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      {/* Text */}
      {showText && (
        <span
          className={`font-heading font-bold tracking-tight leading-none ${s.text}`}
          style={{ color: isDark ? "#ffffff" : "#1a1a2e" }}
          data-testid="app-logo-text"
        >
          <span
            style={{
              background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 40%, #06b6d4 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            Audio
          </span>{" "}
          Ideias
        </span>
      )}
    </div>
  );
};

export default AppLogo;
